import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  InputBase,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Divider,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import EditIcon from "@mui/icons-material/Edit";
import GetAppIcon from "@mui/icons-material/GetApp";
import AddIcon from "@mui/icons-material/Add";

const VendorPurchaseOrder = () => {
  // Sample data for purchase orders
  const purchaseOrders = [
    { 
      id: "PO-2024-0001", 
      date: "Mar 11, 2024",
      amount: "979632.66",
      status: "Approved"
    },
    { 
      id: "PO-2024-0002", 
      date: "Mar 12, 2024",
      amount: "599022.64",
      status: "Approved"
    },
    { 
      id: "PO-2024-0003", 
      date: "Mar 13, 2024",
      amount: "974621.05",
      status: "Approved"
    },
    { 
      id: "PO-2024-0004", 
      date: "Mar 14, 2024",
      amount: "936612.66",
      status: "Approved"
    },
    { 
      id: "PO-2024-0005", 
      date: "Mar 15, 2024",
      amount: "699700.90",
      status: "Approved"
    },
  ];

  const getStatusColor = (status) => {
    switch(status) {
      case "Approved":
        return { bg: "#DCFCE7", color: "#10B981" };
      case "Pending":
        return { bg: "#FEF3C7", color: "#F59E0B" };
      case "Rejected":
        return { bg: "#FEE2E2", color: "#EF4444" };
      default:
        return { bg: "#F3F4F6", color: "#6B7280" };
    }
  };

  return (
    <div className="page-container">
      <Card
        className="shadow-sm"
        variant="outlined"
        sx={{
          border: "1px solid lightgray",
          borderRadius: "10px",
          width: "100%",
        }}
      >
        <CardHeader
          title={<Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px', color: '#333' }} className="font-rubik">Purchase Orders</Typography>}
          action={
            <div>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{
                  marginRight: "8px",
                  backgroundColor: "#050092",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#050092" },
                  fontWeight: 400,

                }}
                className="font-rubik"
              >
                New Order
              </Button>
            </div>
          }
          sx={{
            margin: "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        />
        <Divider sx={{ backgroundColor: "darkgray" }} />
      
      <CardContent>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
          <Paper
            component="form"
            sx={{ 
              p: '2px 4px', 
              display: 'flex', 
              alignItems: 'center', 
              width: 250,
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              boxShadow: 'none'
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search orders..."
              inputProps={{ 'aria-label': 'search orders' }}
            />
            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper>

          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            sx={{ 
              borderColor: '#e0e0e0',
              color: '#6B7280',
              textTransform: 'none',
              borderRadius: '8px',
            }}
          >
            Filter
          </Button>
        </Box>

        {/* <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ 
            bgcolor: "#050092",
            "&:hover": { bgcolor: "#050092" },
            borderRadius: '8px',
            textTransform: 'none',
            display: { xs: 'none', sm: 'flex' }
          }}
        >
          New Order
        </Button> */}
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid #f0f0f0', borderRadius: '8px' }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ backgroundColor: '#f9fafb' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>ORDER ID</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>DATE</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>AMOUNT</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>STATUS</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {purchaseOrders.map((order) => {
              const statusStyle = getStatusColor(order.status);
              return (
                <TableRow key={order.id} hover>
                  <TableCell component="th" scope="row">
                    <Typography variant="body2" sx={{ fontWeight: 'medium', color: '#111827', fontFamily: 'Rubik' }}>
                      {order.id}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ color: '#6B7280', fontFamily: 'Rubik' }}>
                      {order.date}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ color: '#6B7280', fontFamily: 'Rubik' }}>
                      {order.amount}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={order.status} 
                      sx={{ 
                        bgcolor: statusStyle.bg, 
                        color: statusStyle.color,
                        fontWeight: 'medium',
                        borderRadius: '16px',
                        fontSize: '0.75rem',
                        height: '24px'
                      }} 
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <IconButton size="small" sx={{ color: '#6B7280' }}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton size="small" sx={{ color: '#6B7280' }}>
                        <GetAppIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      </CardContent>
      </Card>
    </div>
  );
};

export default VendorPurchaseOrder;
